






import Vue from "vue";

export default Vue.extend({
    props: {
        title: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        }
    }
})
